import React, { useContext, useEffect } from 'react';
import PdfReport from '../../../components/Pdf';
import { buriedPoint, typeIdObj } from '@/pages/home/utils/buriedPoint';
import { StudioContext } from '../context';
import StudioState from '../components/StudioState';

const Pdf = () => {
  const { currentGame, currentMenu, menuPermission } = useContext(StudioContext);
  useEffect(()=> {
    if(!currentMenu){
      return;
    }

    const { game_code: gameCode } = currentGame;
    const { id = '', name_en: nameEn } = currentMenu || {};
    const logObj = {
      pageId: '100901', 
      menuId: id,
      pageName: nameEn,
      extInfo: nameEn,
      pagePath: `/pdf/report/${nameEn || ''}`,
      uid: gameCode || '',
      typeId: typeIdObj.studio,
      gameName: currentGame?.game_name,
    };
    buriedPoint(logObj);

  },[currentGame, currentMenu]);

  if (menuPermission === false) {
    return <StudioState isNoPermission={true} />;
  }

  return (
    <>
      {
        currentMenu?.url ? <PdfReport url={currentMenu?.url} className='db-studio-iframe-wrap'/> : <StudioState/>
      }
    </>
  );
};

export default Pdf;